<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <div>
      <div class="bg-dark m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60 align-items-center justify-content-center">
            <div class="col-md-6 text-center text-white">
              <div class="bg-white rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center" style="width:64px;height:64px;">
                <i class="fe fe-user text-dark" style="font-size:1.8rem;"></i>
              </div>
              <div class="h5 mb-2">{{ dependent.full_name }}</div>
              <span v-if="dependent.status == 'active'">
                <span class="badge badge-soft-success px-3 py-2 my-2" style="border-radius:20px;font-size:0.8rem;">
                  <i class="fe fe-check-circle mr-1"></i> Active
                </span>
              </span>
              <span v-else>
                <span class="badge badge-soft-warning px-3 py-2 my-2" style="border-radius:20px;font-size:0.8rem;">
                  <i class="fe fe-alert-circle mr-1"></i> Inactive
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <section class="pull-up">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30">
                <div class="card-header border-bottom">
                  <h6 class="mb-0"><i class="fe fe-user text-info mr-2"></i>Dependent Profile</h6>
                </div>

                <div class="card-body row">
                  <div class="col-md-3 text-center border-right pt-3">
                    <vue-initials-img
                      :name="dependent.firstname + ' ' + dependent.lastname"
                      class="rounded-circle mx-auto mb-3"
                      style="width:100px;height:100px;"
                      v-if="dependent.image == null"
                    />
                    <div v-if="dependent.image != null" class="mb-3">
                      <img
                        :src="`${dependent.image_url}`"
                        class="rounded-circle"
                        style="width:100px;height:100px;object-fit:cover;"
                      />
                    </div>
                    <p class="font-weight-bold mb-0">{{ dependent.firstname }} {{ dependent.lastname }}</p>
                    <small class="text-muted">Dependent</small>
                  </div>

                  <div class="col-md-9 p-0">
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-user text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Name</p>
                          <p class="font-weight-bold mb-0">{{ dependent.firstname }} {{ dependent.lastname }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-credit-card text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Enrollee ID</p>
                          <p class="font-weight-bold mb-0">{{ dependent.id_card_number }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-users text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Principal</p>
                          <p class="font-weight-bold mb-0">{{ dependent.user.full_name }} ({{ dependent.user.id_card_number }})</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-phone text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Phone Number</p>
                          <p class="font-weight-bold mb-0">{{ dependent.phone_number }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start" v-if="dependent.localgovt">
                        <i class="fe fe-map-pin text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">LGA</p>
                          <p class="font-weight-bold mb-0">{{ dependent.localgovt.local_name }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-gift text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Date of Birth</p>
                          <p class="font-weight-bold mb-0">{{ dependent.dob | moment("dddd, MMMM Do YYYY") }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-user text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Gender</p>
                          <p class="font-weight-bold mb-0">{{ dependent.gender }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-link text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Relationship Type</p>
                          <p class="font-weight-bold mb-0">{{ dependent.relationShipType }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-hash text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">NIN</p>
                          <p class="font-weight-bold mb-0">{{ dependent.nimc_number }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-calendar text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Expiry Date</p>
                          <p class="font-weight-bold mb-0">{{ dependent.expiry_date | moment("dddd, MMMM Do YYYY") }}</p>
                        </div>
                      </li>
                    </ul>

                    <div class="px-3 pt-3 pb-2 border-top">
                      <h6 class="text-muted mb-3" style="font-size:0.75rem;text-transform:uppercase;letter-spacing:0.05em;">
                        <i class="fe fe-activity mr-1"></i> Activities
                      </h6>
                      <div v-if="activities && activities.data && activities.data.length">
                        <div v-for="activity in activities.data" :key="activity.id" class="media mb-3">
                          <div class="avatar-sm bg-light rounded-circle d-flex align-items-center justify-content-center mr-3" style="width:36px;height:36px;flex-shrink:0;">
                            <i class="fe fe-user text-secondary" style="font-size:0.85rem;"></i>
                          </div>
                          <div class="media-body">
                            <p class="mb-0 font-weight-bold" style="font-size:0.85rem;">{{ activity.causer.full_name }}</p>
                            <span class="badge badge-soft-info">{{ activity.description }}</span>
                            <small class="text-muted d-block mt-1">{{ activity.created_at | moment("from", "now") }}</small>
                          </div>
                        </div>
                      </div>
                      <p v-else class="text-muted text-center py-2" style="font-size:0.85rem;">
                        <i class="fe fe-inbox mr-1"></i> No activities recorded
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="modal fade"
            id="example_01"
            tabindex="-1"
            role="dialog"
            aria-labelledby="example_02"
            aria-hidden="true"
          >
            <div
              class="modal-dialog modal-dialog-centered modal-lg"
              role="document"
            >
              <div class="modal-content">
                <div class="container-fluid">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <div class="row">
                    <div class="col-md-12 p-t-20 p-b-20">
                      <video
                        id="video"
                        width="100%"
                        height="auto"
                        autoplay
                      ></video>
                      <p>
                        <!-- <button id="snap" class="bg-navy btn btn-flat">Snap Photo</button> -->
                        <button @click="takePic" class="bg-navy btn btn-flat">
                          Snap Photo
                        </button>
                        <button
                          type="button"
                          class="btn btn-info"
                          name="button"
                          @click="savePic"
                        >
                          Save pic
                        </button>
                      </p>
                      <!-- <p> i am image  <img :src="imagefile" alt=""> </p> -->
                      <!-- <p>{{imagefile}}</p> -->

                      <canvas id="canvas" width="720px" height="550px"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal Ends -->
        </div>

        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            loader="dots"
            :can-cancel="true"
            :is-full-page="fullPage"
          ></loading>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
// import { WebCam } from "vue-web-cam";

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      user: null,
      dependent: "",
      notes: "",
      medications: "",
      image: "",
      edit: false,
      isLoading: false,
      fullPage: true,
      agency_id: "",
      imagefile: "",
      activities: "",
      pictureShower: true,
    };
  },
  mounted() {
    //
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/getSpeicifDependant/${this.$route.params.id}`)
      .then((response) => {
        this.dependent = response.data.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  methods: {
    attachPic(event) {
      this.user = JSON.parse(localStorage.getItem("user"));

      console.log(event);
      // let files = event.target.files
      // let filename = event.target.files[0].name
      this.image = event.target.files[0];
      this.uploadPic();
    },
    uploadPic() {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));

      var formData = new FormData();
      formData.append("user_image", this.image);
      formData.append("dependant_id", this.$route.params.id);
      this.axios
        .post(
          "/api/v1/auth/uploadDependantImage",
          // {user_image: this.image, dependant_id: this.$route.params.id}
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$breadstick.notify("Profile Image changed Successfully!", {
            position: "top-right",
          });
          this.fetchUser();
        });
    },
    takePic() {
      var video = document.getElementById("video");
      var canvas = document.getElementById("canvas");
      var context = canvas.getContext("2d");

      context.drawImage(video, 0, 0, 640, 480);

      // get image
      var image = new Image();
      image.src = canvas.toDataURL("image/png");
      console.log(image);
      localStorage.setItem("snap", this.imagefile.src);
      this.imagefile = image.src;

      // upload image

      // end of upload image
    },

    savePic() {
      this.axios
        .post(`/api/v1/auth/uploadcustomerpicImage`, {
          user_image: this.imagefile,
          user_id: this.$route.params.id,
        })
        .then((response) => {
          console.log(response);
          this.$breadstick.notify("Profile Image changed Successfully!", {
            position: "top-right",
          });
          this.fetchUser();
        })
        .catch((error) => {
          console.error(error);
        });
    },

    fetchUser() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/getSpeicifDependant/${this.$route.params.id}`)
        .then((response) => {
          this.dependent = response.data.data;
           this.activities = response.data.activities;

          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    uploadPicSnapped() {
      this.isLoading = true;
      let snap = localStorage.getItem("snap");

      var formData = new FormData();
      formData.append("user_image", snap);
      this.axios
        .post("/api/v1/auth/uploadUserImage", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$breadstick.notify("Profile Image changed Successfully!", {
            position: "top-right",
          });
          // this.getUser()
        });
    },
  },
  created() {
    this.fetchUser();
  },
};
</script>
<style >
.spacer {
  margin-left: 15px;
}
.spacer-top-bottom {
  margin-top: 7px;
  margin-bottom: 7px;
}
#container {
  margin: 0px auto;
  width: 500px;
  height: 375px;
  border: 10px #333 solid;
}
#videoElement {
  width: 500px;
  height: 375px;
  background-color: #666;
}
</style>
